import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  progressCompleteLabel: {
    id: 'patient_search_refiner.progress_complete_label',
    description: 'Progress label for the patient search refiner',
    defaultMessage: '{percent}% complete.'
  },
  header: {
    id: 'patient_search_refiner.header',
    description: 'Header for the patient search refiner',
    defaultMessage: 'We can help find doctors who specialize in what you need.'
  },
  noResultsLabel: {
    id: 'patient_search_refiner.no_results_label',
    description: 'Label for no results found for the patient search refiner',
    defaultMessage: 'No Results'
  },
  backButtonLabel: {
    id: 'patient_search_refiner.back_button_label',
    description: 'Label for the back button for the patient search refiner',
    defaultMessage: 'Back'
  },
  skipButtonLabel: {
    id: 'patient_search_refiner.skip_button_label',
    description: 'Label for the skip button for the patient search refiner',
    defaultMessage: 'Skip to search results'
  },
  disclaimer: {
    id: 'patient_search_refiner.disclaimer',
    description: 'Disclaimer for the patient search refiner',
    defaultMessage:
      'This screening tool helps you find providers by narrowing search results based on your preferences. This tool does not provide medical advice, diagnosis, or treatment recommendations. The choice of healthcare provider remains entirely yours in consultation with your current providers. If this is a medical emergency, call 911.'
  }
});
